import { gsap } from "gsap";
import { createAPNGPlayer } from "./tokyodome/createAPNGPlayers.es6";
import { handleLottieAnime } from "./tokyodome/handleLottieAnime.es6";
import glitch from "./tokyodome/glitch.es6";

async function main() {
    const logoContainer = document.querySelector("[data-lottie-id=\"logo\"]");

    const bgVideo = document.querySelector(".tokyodome__video");

    const [dome, logo1] = await Promise.all([
        createAPNGPlayer("tokyodome"),
        handleLottieAnime(logoContainer, "tokyodome_logo", {
            loop: false,
            targetDuration: 5.6, // CSSのアニメーション時間と同期
        })
    ]);

    // パーツごとのアニメーション
    function DomeInAnm() {
        // apngアニメーション
        dome.play();
        gsap.to(".tokyodome__anime", { duration: 0.5, scale: 1, opacity: 1 });
    }

    function LogoAnm() {
        // Lottieアニメーション
        logo1.play();
    }

    // 全体のアニメーション
    const tl = gsap.timeline({});
    tl.add(() => {
        bgVideo.classList.add("-play");
    }).add(() => {
        const mv = document.querySelector(".js-mv");
        mv.classList.add("-inview");
        DomeInAnm();
        LogoAnm();
    }, "+=1.5");

    // グリッチの実行
    new glitch();
}

main();